import React from 'react';
import { AppBar, IconButton, Toolbar, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';

function Header() {

  const { logout } = useAuth();

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
    <Toolbar>
      <Typography variant="h6" noWrap component="div" sx={{ flexGrow: 1 }}>
        OCR Application
      </Typography>
      <IconButton color="inherit" onClick={logout}>
        <LogoutIcon />
      </IconButton>
    </Toolbar>
  </AppBar>
  );
}

export default Header;
